import gql from "graphql-tag";

export const deleteExpertServiceById = gql`
  mutation DeleteExpertServiceById($id: ID!) {
    deleteExpertService(where: { id: $id }) {
      id
    }
  }
`;
